export enum TradingAccountStatus {
    ACTIVE = 'active',
    SUSPENDED = 'suspended',
    CANCELLED = 'cancelled',
    DELETED = 'deleted',
    IN_PROGRESS = 'in-progress',
    PASSED = 'passed',
    FAILED = 'failed'
}
export const TradingAccountStatusLabels = {
    [TradingAccountStatus.ACTIVE]: 'Active',
    [TradingAccountStatus.SUSPENDED]: 'Suspended',
    [TradingAccountStatus.CANCELLED]: 'Cancelled',
    [TradingAccountStatus.DELETED]: 'Deleted',
    [TradingAccountStatus.IN_PROGRESS]: 'In Progress',
    [TradingAccountStatus.PASSED]: 'Passed',
    [TradingAccountStatus.FAILED]: 'Failed'
};

export const TradingAccountStatusOpts = [
    { key: TradingAccountStatus.ACTIVE, label: 'Active' },
    { key: TradingAccountStatus.SUSPENDED, label: 'Suspended' },
    { key: TradingAccountStatus.CANCELLED, label: 'Cancelled' },
    { key: TradingAccountStatus.DELETED, label: 'Deleted' },
    { key: TradingAccountStatus.IN_PROGRESS, label: 'In Progress' },
    { key: TradingAccountStatus.PASSED, label: 'Passed' },
    { key: TradingAccountStatus.FAILED, label: 'Failed' }
];

export const TradingAccountStatusColor = {
    [TradingAccountStatus.ACTIVE]: 'success',
    [TradingAccountStatus.SUSPENDED]: 'warning',
    [TradingAccountStatus.CANCELLED]: 'error',
    [TradingAccountStatus.DELETED]: 'error',
    [TradingAccountStatus.IN_PROGRESS]: 'default',
    [TradingAccountStatus.PASSED]: 'success',
    [TradingAccountStatus.FAILED]: 'error'
};
/* eslint-disable no-unused-vars */
export enum TradingAccountTypes {
    TRADING_DEMO = 'trading_demo',
    TRADING_LIVE = 'trading_live',
    PROP_ORDINARY = 'prop_ordinary',
    PROP_CHALLENGE = 'prop_challenge',
    PROP_CHALLENGE_TRIAL = 'prop_challenge_trial',
    PROP_FUNDED = 'prop_funded',
    PROP_FUNDED_TRIAL = 'prop_funded_trial'
}

export const TradingAccountTypesLabels = {
    [TradingAccountTypes.TRADING_DEMO]: 'Demo',
    [TradingAccountTypes.TRADING_LIVE]: 'Live',
    [TradingAccountTypes.PROP_ORDINARY]: 'Ordinary',
    [TradingAccountTypes.PROP_CHALLENGE]: 'Challenge',
    [TradingAccountTypes.PROP_CHALLENGE_TRIAL]: 'Challenge Trial',
    [TradingAccountTypes.PROP_FUNDED]: 'Funded',
    [TradingAccountTypes.PROP_FUNDED_TRIAL]: 'Funded Trial'
};

export enum AccountAgreementStatuses {
    SENT = 'sent',
    PENDING = 'pending',
    SIGNED = 'signed'
}

export type TableData = {
    data: any[];
    headers: string[];
    loading: boolean;
    load: VoidFunction;
};
export type Account = {
    _id: string;
    platform_login: number;
    balance: number;
    trading_platform: { type: string };
    currency: string;
    status: TradingAccountStatus;
    leverage: number;
    group: string;
    group_alias: string;
    group_display_name: string;
    live_account: boolean;
    platform_type: string;
    country: string;
    country_alpha2: string;
    deleted: boolean;
    archived: boolean;
    type?: TradingAccountTypes;
    type_str: string;
    trading_scheme: string;
    trading_days: number;
    account_age: number;
    inactive_days_count: number;
    created_at?: string;
    updated_at?: string;
    prop_trading_config: {
        initial_deposit: number;
        max_withdrawal_amount: number;
        profit_cap: number;
        profit_split: number;
        is_funded: boolean;
        is_challenge: boolean;
        customer_kyc_approved: boolean;
        minimum_trading_days: number;
        minimum_trading_days_completed: boolean;
        minimum_account_age: number;
        is_account_age_reached: boolean;
        withdrawal_count_limit: number;
        withdrawals_count_by_interval: number;
        withdrawal_day_limit_interval: number;
        has_open_trades: boolean;
        next_date_available_for_withdrawals?: string;
        minimum_withdrawal_amount: number;
        trial_days: number;
        has_scaled?: boolean;
    };
    challenge_state: {
        profit_target_passed: boolean;
        min_trading_days_passed: boolean;
        passed_at: string;
    };
    product?: {
        _id: string;
        price: number;
        name: string;
    };
    is_trial: boolean;
    is_trial_free: boolean;
    is_trial_active: boolean;
    purchase_order: {
        number: number;
        currency: string;
    };
    enable_read_only?: boolean;
    agreement_status?: string;
    status_failed_at?: string;
    status_cancelled_at?: string;
    is_tournament_account?: boolean;
};
export enum AccountType {
    live,
    demo
}
